export default __webpack_public_path__ + "static/media/API.4545ef24.svg";